import { FunctionComponent } from "react";
import Typewriter from "typewriter-effect";
import styles from "./typeWriterText.module.scss";

const TypeWriterText: FunctionComponent = () => {
  const typeWriterList = ["frontend.", "design.", "innovation."];

  return (
    <span className={styles.typeWriterWrapper}>
      <Typewriter
        options={{
          strings: typeWriterList,
          autoStart: true,
          loop: true,
        }}
      />
    </span>
  );
};

export default TypeWriterText;
